import { NgInject } from '@df/ng/ng-inject';
import { TimeoutService } from '@df/ng/timeout.service';
import find from 'lodash-es/find';
import findIndex from 'lodash-es/findIndex';
import { Subject } from 'rxjs';

export interface IGroupBlock {
    groupName: string;
    blockId: any;
    open: () => boolean;
    hide: () => void;
}

export class BlockStatus {
    /**
     * Currently open blocks.
     *
     * @type {IGroupBlock[]}
     */
    private currentlyOpen: IGroupBlock[] = [];

    private awaiting: IGroupBlock[] = [];

    @NgInject(TimeoutService)
    private timeoutService!: TimeoutService;

    /**
     * Popups (on tiem show blocks etc) observale
     */
    private subject = new Subject<BlockStatus>();

    constructor() {
        this.subject.subscribe(() => this.onNext());
    }

    private onNext() {
        this.awaiting.find(item => item?.open());
    }

    private canOpenBlock(block: any): boolean {
        return !find(this.currentlyOpen, { block }) && !find(this.awaiting, { block });
    }

    private canOpenGroup(groupName = ''): boolean {
        return !find(this.currentlyOpen, { groupName });
    }

    /**
     * Used to show one popup in gruop
     * when we want to show another it will be put in queue and shown when possible.
     *
     * show method must return true if show was successful
     */
    groupShow(blockId: any, groupName: string | undefined, force = false, show: () => boolean, hide: () => void): void {
        if (!groupName) {
            show();
            return;
        }

        const open = () => {
            // do nothins if already open this block exactlu
            if (!this.canOpenBlock(blockId)) {
                return false;
            }

            this.clean(blockId);

            const groupBlock: IGroupBlock = {
                blockId,
                groupName,
                open,
                hide
            };

            if (force) {
                this.currentlyOpen.filter(i => i.groupName === groupName).forEach(i => i.hide());
            } else {
                //    nothins if already open block group
                if (!this.canOpenGroup(groupName) && !find(this.awaiting, { blockId })) {
                    this.awaiting.push(groupBlock);
                    return false;
                }
            }

            this.currentlyOpen.push(groupBlock);

            // now show it
            return show();
        };

        open();
    }

    private clean(blockId: any) {
        [this.currentlyOpen, this.awaiting].forEach(table => {
            const index = findIndex(table, { blockId });

            if (index > -1) {
                table.splice(index, 1);
            }
        });
    }

    /**
     * Removes block from opened, please notify when closing groups.
     *
     * @param {*} block
     * @memberof BlockStatus
     */
    public groupCloseNotify(blockId: any): void {
        this.timeoutService.setTimeout(() => {
            this.clean(blockId);
            this.subject.next(this);
        }, 100);
    }
}

export const blockStatus = new BlockStatus();
